import React from 'react';
import { HUBSPOT_FORM_SOURCE } from '/src/lib/constants';
import { PUBLIC_IMG_URL } from '/src/lib/endpoints';

import LandingPageComponent from './components/LandingPageComponent';

const FundsDirectoryLanding = (props) => {

    const contactFormConfig = {
        contactSalesPage: HUBSPOT_FORM_SOURCE.funds_dir_locked_section
    };

    const customFeaturesData = ({ totalFunds }) => [
        {
            id: 'fund-landscape',
            title: 'Explore the Fund Landscape at a Glance',
            description: `From early-stage venture vehicles to billion-dollar growth funds, our funds directory tracks ${totalFunds} funds. Track capital raised, fund managers, industry focus and limited partners, all in one place.`,
            image: `${PUBLIC_IMG_URL}/directory-landing/funds-directory.webp`,
            altText: 'Fund Directory Feature',
            buttonText: `Speak to our Team`,
        },
        {
            id: 'matching-funds',
            title: 'Pinpoint the drivers behind the funding landscape',
            description: `Refine your search with advanced filters across geography, industry, stage, and mandate. Whether you're mapping active funds or exploring the LP landscape, the drivers behind the funding landscape are just a few clicks away.`,
            image: `${PUBLIC_IMG_URL}/directory-landing/filter-search.webp`,
            altText: 'Fund Search Feature',
            buttonText: `Book a Demo`,
        }
    ];

    const customPageMetadata = ({ totalFunds }) => ({
        pageTitle: 'Funds Directory Landing Page',
        title: `Your Access to ${totalFunds} Venture & Growth Funds`,
        description: "Access verified information on fund strategies, LPs and the investment activity that's shaping the venture capital landscape.",
        url: '/funds',
        componentName: 'FundsDirectoryLanding',
        landingPageType: 'Funds',
        amplitudeEvent: 'Clicked Contact Sales from Funds Directory Landing Page',
        heroButtonText: 'Learn More',
    });

    return (
        <LandingPageComponent
            contactFormConfig={contactFormConfig}
            customFeaturesData={customFeaturesData}
            customPageMetadata={customPageMetadata}
            className="funds-directory-landing-container"
            showVideoSection={false}
            location={props.locationSearch}
        />
    );
};

export default FundsDirectoryLanding;
